import type { StorageDto } from "@bafe/api-client";
import { StorageMeter } from "@bafe/ui";
import type { ReactNode } from "react";

export interface AccountStorageSummaryProps {
	storage: StorageDto;
	action?: ReactNode;
	/**
	 * Counts describe what exists. They are never an allowance, because Key
	 * sells a storage pool and not inbox seats (spec §78A).
	 */
	showCounts?: boolean;
	className?: string;
}

export function AccountStorageSummary({
	storage,
	action,
	showCounts = true,
	className,
}: AccountStorageSummaryProps) {
	return (
		<div className={className}>
			<StorageMeter
				usedBytes={storage.usedBytes}
				totalBytes={storage.totalBytes}
				level={storage.level}
				summary={storage.summary}
				mailboxCount={showCounts ? storage.mailboxCount : undefined}
				domainCount={showCounts ? storage.domainCount : undefined}
				action={action}
			/>
		</div>
	);
}
